// extracted by mini-css-extract-plugin
module.exports = {"votesInput":"AddErc20Asset_votesInput__1oc4x","tokenIdInput":"AddErc20Asset_tokenIdInput__3jo48"};